import { render, staticRenderFns } from "./NsHeaderDrawer.vue?vue&type=template&id=787accaf&"
import script from "./NsHeaderDrawer.vue?vue&type=script&lang=js&"
export * from "./NsHeaderDrawer.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderDrawer.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports